// src/pages/admin/AdminRefPricing.jsx
// Page admin des prix de référence (table ref_pricing) — utilisée par la valorisation CUP.
// Monte RefPricingList (liste + recherche + tri + pagination + éditeur modal intégré).
import React from "react";
import RefPricingList from "../../components/RefPricingAdminComponents";

export default function AdminRefPricing() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Prix de référence (CUP)</h1>
        <p className="mt-1 text-sm text-gray-500">
          Règles de prix de référence par artiste / mouvement / médium, utilisées par la
          valorisation comparative. Recherche, tri et édition intégrés.
        </p>
      </div>
      <RefPricingList />
    </div>
  );
}
